<template>
    <BaseSliderCore
        :items="items"
        :controls-enabled="controlsEnabled"
        :pagination-enabled="controlsEnabled"
        :pagination-type="paginationType"
        :track-intersection="true"
        class="base-slider"
        :class="{
            'base-slider--compact': padding === 'compact',
            'base-slider--image-width': padding === 'image-width'
        }"
        v-bind="$attrs"
    >
        <template v-slot:slide="{ item, index }">
            <div
                class="base-slider__slide"
                drag-to-scroll="ignore"
                :draggable="false"
            >
                <slot
                    :name="`slide-${index}`"
                    :item="item"
                />
            </div>
        </template>

        <template v-slot:controlLeftLabel>
            <BaseIcon icon="arrow" />
            <span class="sr-only">
                Move to the left
            </span>
        </template>

        <template v-slot:controlRightLabel>
            <BaseIcon icon="arrow" />
            <span class="sr-only">
                Move to the right
            </span>
        </template>
    </BaseSliderCore>
</template>

<script setup>
import BaseIcon from './BaseIcon.vue';

defineOptions({
    name: 'BaseSlider'
});

defineProps({
    items: {
        type: Array,
        required: true,
        default: () => []
    },
    controlsEnabled: {
        type: Boolean,
        default: false
    },
    paginationType: {
        type: String,
        default: 'label' // 'label' or 'scroll'
    },
    padding: {
        type: String,
        default: 'default',
        validator: (value) => {
            return ['default', 'compact', 'image-width', 'spacious'].includes(value);
        }
    }
});
</script>

<style lang="less">
.base-slider {
    --slider-gap: 1.5rem;

    position: relative;
    min-height: 3.125rem;
    width: 100%;

    display: flex;
    justify-content: center;


    @media @q-md-min {
        --slider-gap: 3.125rem;
    }

    .slider__item {
        white-space: normal;
    }
}

.base-slider--compact {
    --slider-gap: .875rem;

    @media @q-md-min {
        --slider-gap: var(--spacing-lg);
    }
}

.base-slider--spacious {
    --slider-gap: 1.5rem;

    @media @q-md-min {
        --slider-gap: 4.8125rem;
    }
}

//.base-slider__pagination {}

.slider__control {
    appearance: none;
    border: 0.8px solid currentColor;
    bottom: 0;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    height: 2.5rem;
    width: 2.5rem;
    background: transparent;
    color: inherit;
    border-radius: 50%;

    cursor: pointer;
    transition: all var(--transition-timing-fast) 0ms var(--transition-timingFunction-in-out);

    &:not(.slider__control--disabled):hover {
        transform: scale(1.1);
    }

    .base-icon {
        font-size: 2rem;
    }

    svg {
        height: auto;
    }

    &[data-left] {
        //left: var(--grid-gutter-margin);

        .base-icon {
            transform: scaleX(-1);
        }
    }

    &[data-right] {
        //right: var(--grid-gutter-margin);
    }
}


.base-slider.base-slider--image-width {
    --slider-gap: 0;
    width: 100%;

    .slider__item {
        width: 100%;
    }

    .slider__padding {
        display: none;
    }

    .drag-to-scroll .slider__track {
        scroll-snap-type: x mandatory;
    }

    @media @q-lg-min {
        width: 50%;
    }
}

.slider__padding {
    scroll-snap-align: start;
    display: inline-block;
    flex: 0 0 auto;
    margin: 0;
}

.slider__padding:first-child,
.slider__padding:last-child {
    width: clamp(
        calc(
            var(--grid-gutter-margin)
        ), 100vw, calc(
            ((100vw - var(--grid-maxWidth-page)) / 2) +
            var(--grid-gutter-margin)
        )
    );
}

.property-list-slider {
    .slider__track {
        flex: unset;
    }

    .slider__padding:last-child {
        width: clamp(
            calc(var(--grid-gutter-margin)), 100vw, calc( ((100vw - var(--grid-maxWidth-page)) / 2) + var(--grid-gutter-margin))
        );
    }
}

.slider__control--disabled {
    opacity: 0.6;
}

.slider__pagination button {
    color: var(--text-color);
}
</style>
